import { Fee } from "../../models";

export function formatFeeDateTime(fee: Fee): string | null {
    if (fee.isStartedOnEntryDate) {
        if (fee.startDate) {
            const startDate: string = fee.startDate;
            const startTime = fee.startTime || "23:59:59.999";
            return `${startDate}${startTime}`;
        }
    }
    return null;
}